// Angular
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router'
// Local services
import { ClienteService } from '../../services/cliente.service';
// 3rd libraries
import { NgxUiLoaderService } from 'ngx-ui-loader';
import swal from 'sweetalert2';

@Component({
  selector: 'app-gestiones-aplica-credito',
  templateUrl: './gestiones-aplica-credito.component.html',
  styleUrls: ['./gestiones-aplica-credito.component.scss']
})
export class GestionesAplicaCreditoComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService;
  @Output() setDataCliente = new EventEmitter<any>();
  @Input() datacliente: any;
  minimumAmount = 0;
  isLiquidez = false;
  monto
  plazo
  formatterDecimal = new Intl.NumberFormat('es-GT', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'decimal',
  });
  constructor(private ngxUiLoaderService: NgxUiLoaderService,
    public router: Router) {
    setTimeout(() => {
      this.ngxUiLoaderService.stopLoader(
        "loader-global",
        "loadingDashboard"
      );
      if (this.clienteserviceParam.datosPrecalificacion.monto != null) {
        this.monto = this.clienteserviceParam.datosPrecalificacion.monto
        this.plazo = this.clienteserviceParam.datosPrecalificacion.plazo
      }
    }, 500);
  }

  ngOnInit(): void {

  }
  goToIngresos() {
    if (this.monto==null|| +this.monto<=0) {
      this.showNotification('Alerta','Debe ingresar un monto')
    } else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    (this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="A"||this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="S")&&+this.monto<3500){
      this.showNotification("Alerta", "El monto no debe ser menor a Q3500")
    }
    else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="I"&&+this.monto<8000){
      this.showNotification("Alerta", "El monto no debe ser menor a Q8000")
    }else if(this.clienteserviceParam.datosPrecalificacion.segmento!="PV" && +this.monto<1500){
      this.showNotification("Alerta", "El monto no debe ser menor a Q1500")
    }
    else if (this.monto > 300000) {
      this.showNotification("Alerta", "El monto no debe ser mayor a Q300,000.00");
    }
    else if (this.plazo == null) {
      this.showNotification('Alerta','Debe ingresar un plazo')
    }
    else if (this.plazo.toString().includes('.')) {
      this.showNotification("Alerta", "Debe ingresar un plazo valido");
    }else if (this.plazo<6) {
      this.showNotification("Alerta", "El plazo no debe ser menor a 6 meses");
    }
    else if (this.clienteserviceParam.datosPrecalificacion.segmento!="PV"&& this.plazo>120) {
      this.showNotification("Alerta", "El plazo no debe ser mayor a 120 meses");
    }else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    (this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="A"||this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="S")&&this.plazo>72){
      this.showNotification("Alerta", "El plazo no debe ser mayor a 72 meses");
    }
    else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="I"&&this.plazo>60){
      this.showNotification("Alerta", "El plazo no debe ser mayor a 60 meses");
    }
    else if ((this.monto % 100) != 0) {
      var monto = this.monto / 100;
      var montoMultiplo = parseInt(monto.toString());
      this.monto=montoMultiplo*100
      this.showNotificationMonto('Alerta',"El monto ingresado se pasó al valor de: " +this.monto+" ya que debe de ser múltiplo de 100.")
    }
    else {
      this.clienteserviceParam.setMontoyPlazo({ plazo: this.plazo, monto: this.monto })
      this.clienteserviceParam.TotalCosolidacion =0;
      this.clienteserviceParam.datosPorductosClientes = [];
      this.clienteserviceParam.datosPrecalificacion.montoSolicitudCashOut=0
      this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard")
      this.clienteserviceParam.solicitarOferta()
      .then((result) => {
        this.ngxUiLoaderService.stopLoader(
          "loader-global",
          "loadingDashboard"
        );
        this.clienteserviceParam.datosPrecalificacion.minimumAmount=this.minimumAmount
        if (result == "R") {
          this.selecttab.emit(11);
        } else if (result == "SD") {
          this.showNotificationsinoferta(
            "No se han obtenido ofertas",
            "Por el momento el cliente no tiene ofertas disponibles."
          );
        } else if (result == "A") {
          if (this.clienteserviceParam.ofertasComerciales.ofertaComercial.length == 2 && this.clienteserviceParam.ofertasComerciales.ofertaComercial[0].bienestarMixAndMatchFlg==1) {
            this.clienteserviceParam.ofertaseleccionada = 0
            this.clienteserviceParam.ofertamym=0
            this.selecttab.emit(13)
          } else {
            this.selecttab.emit(12)
          }
        } else {
          this.showNotificationsinoferta(
            "Ha ocurrido un error",
            "Por el momento el cliente no tiene ofertas disponibles."
          );
        }
      })
      .catch((error) => {
        this.ngxUiLoaderService.stopLoader(
          "loader-global",
          "loadingDashboard"
        );
        if (error.codigoError && error.codigoError == "1003") {
          this.showNotificationsinoferta(
            "Aviso",
            error.mensajeTecnicoAPI
          );
        }
        else if (error.codigoError!="0") {
          this.showNotificationError(
            "Aviso",
            'Ha ocurrido un error, intentelo más tarde. Código de error: '+error.codigoError
          );
        }
        else if (error == "errorguardado") {
          this.showNotificationsinoferta(
            "Ha ocurrido un error",
            "No se ha podido guardar la precalificación."
          );
        } else{
          this.showNotificationError(
            "Alerta",
            "No se ha podido establecer conexión con el servidor, intentelo de nuevo."
          );
        }
      });
    }
  }
  showNotificationsinoferta(title, message) {
    swal.fire({
      title: title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {
      this.selecttab.emit(0)
    })
  }
  showNotification(title, message:string) {
    swal.fire({
      title: title,
      text: message,
      padding:'20px',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {
    })
  }
  showNotificationMonto(title, message:string) {
    swal.fire({
      title: title,
      text: message,
      padding:'20px',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {
      this.goToIngresos()
    })
  }
  showNotificationError(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
      });
  }
  goBack() {
    this.selecttab.emit(15)//volver a patrono
  }
}
